import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import { Grid, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import {
  BoldText,
  CardsWrapper,
  CarouselContainer,
  FoodMarketHubIcon,
  GridStyled,
  KraaveIcon,
  LogoWrapper,
  NavigationButtons,
  SingaporeAirline,
  StarbucksIcon,
  StepButton,
  TestimonialSubTitle,
  TestimonialText,
  TestimonialTitle,
  WhackedIcon,
  XperantiIcon,
} from "./styles";

const testimonials = [
  {
    text: `"The branding and marketing for Hiredly platform is good therefore it <b>attracts a lot of candidates</b>"`,
    boldText: "attracts a lot of candidates",
    logo: <StarbucksIcon />,
    backgroundColor: "#EBFDE1",
    borderColor: "#1A4900",
    boxShadowColor: "rgba(26, 73, 0, 0.60)",
    color: "rgba(0, 0, 0, 0.87)",
  },
  {
    text: `"Very <b>targeted and focused</b>, always ready to provide assistance with the ability to secure the perfect candidate for the job"`,
    boldText: "targeted and focused",
    logo: <SingaporeAirline />,
    backgroundColor: "#FFF8EC",
    borderColor: "#CD8A05",
    boxShadowColor: "rgba(205, 138, 5, 0.60)",
    color: "#523400",
  },
  {
    text: `"The job slot function offered by Hiredly has been an invaluable tool for us. This unique feature has allowed us to repost job listings an unlimited number of times without incurring additional costs, which has helped us <b>save a significant amount of money</b>"`,
    boldText: "save a significant amount of money",
    logo: <KraaveIcon />,
    backgroundColor: "#FFF9FB",
    borderColor: "#5D001F",
    boxShadowColor: "rgba(93, 0, 31, 0.60)",
    color: "#5D001F",
  },
  {
    text: `"Experience a greater variety of good talent candidates to choose from the Hiredly portal. Benefit from good client relations demonstrated through <b>proactive assistance</b>"`,
    boldText: "proactive assistance",
    logo: <FoodMarketHubIcon />,
    backgroundColor: "#FFFAF4",
    borderColor: "#5F545A",
    boxShadowColor: "rgba(178, 110, 20, 0.60)",
    color: "#413A3E",
  },
  {
    text: `"<b>Has right pool of people for quick hiring</b>"`,
    boldText: "Has right pool of people for quick hiring",
    logo: <XperantiIcon />,
    backgroundColor: "#F5FAFF",
    borderColor: "#020E31",
    boxShadowColor: "rgba(2, 14, 49, 0.60)",
    color: "#020E30",
    fontSize: "20px",
  },
  {
    text: `"Over time using Hiredly’s portal, we’ve actually received <b>hundreds of applications</b> and recruited most of our employees from the platform itself."`,
    boldText: "hundreds of applications",
    logo: <WhackedIcon />,
    backgroundColor: "#FFEDED",
    borderColor: "#650000",
    boxShadowColor: "rgba(147, 0, 0, 0.60)",
    color: "#650000",
  },
];

export default function EmployerTestimonial() {
  const belowLg = useMediaQuery("(max-width: 1279px)");
  const belowTablet = useMediaQuery("(max-width: 767px)");

  const [step, setStep] = useState(0);

  const handleNextCard = (direction) => {
    if (direction === "left" && step > 0) {
      setStep(step - 1);
    } else if (direction === "right") {
      if (step === testimonials.length - 1) {
        setStep(0);
      } else {
        setStep(step + 1);
      }
    }
  };

  if (belowTablet) {
    return (
      <GridStyled>
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            padding: "56px 24px 0px 24px",
          }}
        >
          <TestimonialSubTitle>
            80k successful hires— and counting
          </TestimonialSubTitle>
          <TestimonialTitle>See Why Employers Choose Us.</TestimonialTitle>
        </Grid>

        <CarouselContainer>
          <CardsWrapper
            style={{
              transform: `translateX(${-step * 94}vw)`,
            }}
          >
            {testimonials.map((testimonial, index) => (
              <TestimonialContainer
                key={index}
                backgroundColor={testimonial.backgroundColor}
                borderColor={testimonial.borderColor}
                boxShadowColor={testimonial.boxShadowColor}
                cardNumber={index}
              >
                <TestimonialText
                  style={{
                    color: testimonial.color,
                    fontSize: testimonial?.fontSize
                      ? testimonial.fontSize
                      : "16px",
                  }}
                  dangerouslySetInnerHTML={{ __html: testimonial.text }}
                ></TestimonialText>
                <LogoWrapper>{testimonial.logo}</LogoWrapper>
              </TestimonialContainer>
            ))}
          </CardsWrapper>
        </CarouselContainer>

        <div
          style={{
            position: "relative",
            display: "flex",
          }}
        >
          <NavigationButtons>
            <StepButton
              onClick={() => handleNextCard("left")}
              disabled={step === 0 || testimonials.length === 0}
            >
              <ArrowLeftIcon height={24} width={24} color="#FFF" />
            </StepButton>

            <StepButton onClick={() => handleNextCard("right")}>
              {step === 5 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.75541 10.0591C5.82748 6.05814 9.94 3.68377 13.941 4.75584C15.262 5.10979 16.4038 5.79398 17.3036 6.69552L19.2067 8.59859H16.023C15.6088 8.59859 15.273 8.93438 15.273 9.34859C15.273 9.76281 15.6088 10.0986 16.023 10.0986H21.0156C21.2145 10.0986 21.4053 10.0196 21.546 9.87889C21.6866 9.73821 21.7656 9.54742 21.7656 9.34849V4.35599C21.7656 3.94178 21.4298 3.60599 21.0156 3.60599C20.6014 3.60599 20.2656 3.94178 20.2656 4.35599V7.53616L18.3653 5.63586C17.2841 4.55278 15.9116 3.73095 14.3292 3.30695C9.52803 2.02047 4.593 4.86971 3.30653 9.67091C3.19932 10.071 3.43676 10.4823 3.83686 10.5895C4.23696 10.6967 4.64821 10.4592 4.75541 10.0591ZM20.1629 13.4111C19.7628 13.3039 19.3515 13.5413 19.2443 13.9414C18.1722 17.9424 14.0597 20.3168 10.0587 19.2447C8.73774 18.8908 7.59594 18.2066 6.69609 17.3051L4.7942 15.4019H7.97702C8.39123 15.4019 8.72702 15.0661 8.72702 14.6519C8.72702 14.2377 8.39123 13.9019 7.97702 13.9019L2.98438 13.9019C2.57016 13.9019 2.23438 14.2377 2.23438 14.6519V19.6446C2.23438 20.0588 2.57016 20.3946 2.98438 20.3946C3.39859 20.3946 3.73438 20.0588 3.73438 19.6446V16.4634L5.63444 18.3647C6.71564 19.4479 8.08796 20.2696 9.67048 20.6936C14.4717 21.9801 19.4067 19.1308 20.6932 14.3297C20.8004 13.9296 20.563 13.5183 20.1629 13.4111Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <ArrowRightIcon height={24} width={24} color="#FFF" />
              )}
            </StepButton>
          </NavigationButtons>
          <div
            style={{
              height: "56px",
            }}
          ></div>
        </div>
      </GridStyled>
    );
  }

  return (
    <GridStyled>
      <Grid sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <TestimonialSubTitle>
          80k successful hires— and counting
        </TestimonialSubTitle>
        <TestimonialTitle>See Why Employers Choose Us.</TestimonialTitle>
      </Grid>

      <Grid sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <Grid
          sx={{
            display: "flex",
            flexDirection: belowLg ? "column" : "row",
            gap: "24px",
          }}
        >
          <Grid
            sx={{
              display: "grid",
              flexDirection: belowTablet ? "column" : "row",
              gap: "24px",
              gridTemplateColumns: !belowTablet && "repeat(2, 1fr)",
            }}
          >
            <TestimonialContainer
              small={true}
              backgroundColor="#EBFDE1"
              borderColor="#1A4900"
              boxShadowColor="rgba(26, 73, 0, 0.60)"
            >
              <TestimonialText>
                “The branding and marketing for Hiredly platform is good
                therefore it <BoldText>attracts a lot of candidates </BoldText>
                that are from our target segment.”
              </TestimonialText>
              <LogoWrapper>
                <StarbucksIcon />
              </LogoWrapper>
            </TestimonialContainer>

            <TestimonialContainer
              small={true}
              backgroundColor="#FFF8EC"
              borderColor="#CD8A05"
              boxShadowColor="rgba(205, 138, 5, 0.60)"
            >
              <TestimonialText sx={{ color: "#523400" }}>
                “Very <BoldText>targeted and focused</BoldText>, always ready to
                provide assistance with the ability to secure the perfect
                candidate for the job”
              </TestimonialText>
              <LogoWrapper>
                <SingaporeAirline />
              </LogoWrapper>
            </TestimonialContainer>
          </Grid>

          <TestimonialContainer
            backgroundColor="#FFF9FB"
            borderColor="#5D001F"
            boxShadowColor="rgba(93, 0, 31, 0.60)"
          >
            <TestimonialText sx={{ color: "#5D001F" }}>
              “The job slot function offered by Hiredly has been an invaluable
              tool for us. This unique feature has allowed us to repost job
              listings an unlimited number of times without incurring additional
              costs, which has helped us{" "}
              <BoldText>save a significant amount of money </BoldText>
              in the process.”
            </TestimonialText>
            <LogoWrapper>
              <KraaveIcon />
            </LogoWrapper>
          </TestimonialContainer>
        </Grid>

        <Grid
          sx={{
            display: "flex",
            flexDirection: belowLg ? "column" : "row",
            gap: "24px",
          }}
        >
          <TestimonialContainer
            backgroundColor="#FFFAF4"
            borderColor="#5F545A"
            boxShadowColor="rgba(178, 110, 20, 0.60)"
          >
            <TestimonialText sx={{ color: "#413A3E" }}>
              “Experience a <BoldText>greater variety of good talent</BoldText>{" "}
              candidates to choose from the Hiredly portal. Benefit from good
              client relations demonstrated through{" "}
              <BoldText>proactive assistance </BoldText>
              from Hiredly's dedicated team.”
            </TestimonialText>
            <LogoWrapper>
              <FoodMarketHubIcon />
            </LogoWrapper>
          </TestimonialContainer>

          <Grid
            sx={{
              display: "grid",
              flexDirection: belowTablet ? "column" : "row",
              gap: "24px",
              gridTemplateColumns: !belowTablet && "repeat(2, 1fr)",
            }}
          >
            <TestimonialContainer
              small={true}
              backgroundColor="#F5FAFF"
              borderColor="#020E31"
              boxShadowColor="rgba(2, 14, 49, 0.60)"
            >
              <TestimonialText sx={{ color: "#020E30", fontSize: "22px" }}>
                <BoldText>“Has right pool of people for quick hiring”</BoldText>
              </TestimonialText>
              <LogoWrapper>
                <XperantiIcon />
              </LogoWrapper>
            </TestimonialContainer>

            <TestimonialContainer
              small={true}
              backgroundColor="#FFEDED"
              borderColor="#650000"
              boxShadowColor="rgba(147, 0, 0, 0.60)"
            >
              <TestimonialText sx={{ color: "#650000" }}>
                “Over time using Hiredly’s portal, we’ve actually received{" "}
                <BoldText> hundreds of applications</BoldText> and recruited
                most of our employees from the platform itself.”
              </TestimonialText>
              <LogoWrapper>
                <WhackedIcon />
              </LogoWrapper>
            </TestimonialContainer>
          </Grid>
        </Grid>
      </Grid>
    </GridStyled>
  );
}

const TestimonialContainer = (props) => {
  const { backgroundColor, borderColor, boxShadowColor, small = false } = props;

  const belowLg = useMediaQuery("(max-width: 1279px)");
  const belowTablet = useMediaQuery("(max-width: 767px)");

  const getWidth = () => {
    if (belowLg && small) {
      return "auto";
    }

    if (small) {
      return "330px";
    }

    return "auto";
  };

  return (
    <Grid
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "24px",
        width: belowTablet ? "auto" : getWidth(),
        minWidth: belowTablet ? "unset" : getWidth(),
        minHeight: belowTablet ? "360px" : "272px",
        backgroundColor: backgroundColor,
        border: `2px solid ${borderColor}`,
        borderRadius: "14px",
        boxShadow: belowTablet
          ? `8px 10px 0px 0px ${boxShadowColor}`
          : `12px 14px 0px 0px ${boxShadowColor}`,
        gap: "24px",
        flex: belowTablet && "0 0 100%",
        maxWidth: belowTablet ? "88vw" : "100%",
      }}
    >
      {props?.children}
    </Grid>
  );
};
